var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDll = function SvgDll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#576D7E",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.635 18c-.198 0-.414-.109-.414-.372v-3.406c0-.216.216-.372.414-.372h1.373c2.74 0 2.68 4.15.054 4.15zm.378-3.418v2.686h.995c1.62 0 1.692-2.687 0-2.687zM9.879 14.21c0-.198.168-.366.378-.366.192 0 .354.169.354.366v3.005h1.63c.588 0 .6.785 0 .785h-1.984c-.21 0-.378-.15-.378-.366zM13.392 14.21c0-.198.168-.366.378-.366.192 0 .354.169.354.366v3.005h1.63c.588 0 .6.785 0 .785H13.77c-.21 0-.378-.15-.378-.366z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgDll;